import { useTranslation } from 'react-i18next';
import AirbnbIcon from 'assets/images/icons/channels/airbnb.svg?react';
import BookingDotComIcon from 'assets/images/icons/channels/booking.svg?react';
import GoogleIcon from 'assets/images/icons/channels/google.svg?react';
import HostfullyIcon from 'assets/images/icons/channels/hostfully.svg?react';
import HvmiIcon from 'assets/images/icons/channels/hvmi.svg?react';
import VrboIcon from 'assets/images/icons/channels/vrbo.svg?react';
import { Channel } from 'models/Channels';
import { SUPPORTED_CHANNELS } from '../PropertySettingsDescriptionsTab.constants';
import { LabelWithTooltipChannelIconsStyled } from '../PropertySettingsDescriptionsTab.styles';
import { DescriptionFields } from '../PropertySettingsDescriptionsTab.types';
import {
  ChannelToFieldVisibilityMapping,
  FieldVisibility,
} from '../PropertySettingsDescriptionsTabFormFields.utils';

interface LabelWithTooltipChannelIconsProps {
  fieldName: DescriptionFields;
}

const isVisibleForChannel = (
  fieldName: DescriptionFields,
  channel: Channel,
) => {
  const fieldVisibility = ChannelToFieldVisibilityMapping[channel]?.[fieldName];

  return (
    fieldVisibility === FieldVisibility.VISIBLE ||
    fieldVisibility === FieldVisibility.VISIBLE_AND_REQUIRED
  );
};

const CHANNEL_ICONS_MAP = {
  [Channel.orbirental]: HostfullyIcon,
  [Channel.airbnb]: AirbnbIcon,
  [Channel.booking_com]: BookingDotComIcon,
  [Channel.homeaway]: VrboIcon,
  [Channel.hvmi]: HvmiIcon,
  [Channel.google]: GoogleIcon,
} as const satisfies Record<
  (typeof SUPPORTED_CHANNELS)[number],
  typeof HostfullyIcon
>;

const CHANNEL_ICONS = SUPPORTED_CHANNELS.map((channel) => ({
  channel,
  Icon: CHANNEL_ICONS_MAP[channel],
}));

const LabelWithTooltipChannelIcons = ({
  fieldName,
}: LabelWithTooltipChannelIconsProps) => {
  const { t } = useTranslation();

  if (fieldName === 'isApplyADifferentLongDescriptionEnabled') {
    return null;
  }

  return (
    <LabelWithTooltipChannelIconsStyled>
      {CHANNEL_ICONS.filter(({ channel }) =>
        isVisibleForChannel(fieldName, channel),
      ).map(({ channel, Icon }) => (
        <Icon
          aria-label={t('common.channels', { context: channel })}
          data-testid={`${channel}-channel-icon`}
          key={channel}
          // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- inline SVG: role="img" + aria-label is correct; there is no <img> to prefer
          role="img"
        />
      ))}
    </LabelWithTooltipChannelIconsStyled>
  );
};

export default LabelWithTooltipChannelIcons;
